import type { CustomerDto } from '../api/common/dto/customer';

export const customerDto: CustomerDto = {
  identifier: 1,
  hotjar_account_id: 1,
  created_at: '2022-10-31T16:27:50.126048',
  company_name: 'Test Company',
  billing_address: {
    address_line1: '142 Elm Street',
    address_line2: '',
    city: 'Nowhere',
    zip_code: '12378',
    country: 'MT',
    state: null,
    county: null,
    first_name: '王詩詩 testuser@hotjar.com',
    last_name: '王詩詩 testuser@hotjar.com',
    email_address: 'testuser@hotjar.com',
  },
  additional_email_addresses: [],
  tax_number: '',
  currency: 'EUR',
  subscription: {
    created: '2022-10-31T16:27:50.126048',
    start_date: '2022-10-31',
    current_period_start_date: '2022-10-31',
    current_period_end_date: '2022-11-29',
    billing_period: 'MONTHLY',
    products: [
      {
        sku: 'SKU-12',
        components_service: [
          {
            identifier: 'SERVICE',
          },
        ],
        components_fixed_volume: [],
        components_selectable_volume: [],
        components_percentage_deduction: [
          {
            identifier: 'AD_HOC_PERCENTAGE',
            application_type: 'RECURRING',
            application_scope: 'PRODUCT_SCOPE',
            percentage: 0,
          },
          {
            identifier: 'ASK_OBSERVE_BUNDLE_DEDUCTION',
            application_type: 'RECURRING',
            application_scope: 'PRODUCT_SCOPE',
            percentage: 20,
          },
        ],
        components_monetary_deduction: [
          {
            identifier: 'AD_HOC_MONETARY',
            application_type: 'RECURRING',
            application_scope: 'PRODUCT_SCOPE',
            amount: 0,
          },
        ],
        entity: {
          entity_identifier: '1',
          entity_type: 'site',
          entity_label: 'Default site 🌐',
        },
      },
      {
        sku: 'SKU-2',
        components_service: [
          {
            identifier: 'SERVICE',
          },
        ],
        components_fixed_volume: [],
        components_selectable_volume: [],
        components_percentage_deduction: [
          {
            identifier: 'AD_HOC_PERCENTAGE',
            application_type: 'RECURRING',
            application_scope: 'PRODUCT_SCOPE',
            percentage: 0,
          },
          {
            identifier: 'ASK_OBSERVE_BUNDLE_DEDUCTION',
            application_type: 'RECURRING',
            application_scope: 'PRODUCT_SCOPE',
            percentage: 20,
          },
        ],
        components_monetary_deduction: [
          {
            identifier: 'AD_HOC_MONETARY',
            application_type: 'RECURRING',
            application_scope: 'PRODUCT_SCOPE',
            amount: 0,
          },
        ],
        entity: {
          entity_identifier: '1',
          entity_type: 'site',
          entity_label: 'Default site 🌐',
        },
      },
      {
        sku: 'SKU-1',
        components_service: [],
        components_fixed_volume: [],
        components_selectable_volume: [],
        components_percentage_deduction: [],
        components_monetary_deduction: [],
        entity: {
          entity_identifier: '1',
          entity_type: 'account',
          entity_label: 'account 1',
        },
      },
    ],
    status: 'ACTIVE',
  },
  current_period_cost_summary: {
    amount_with_tax: 168.04,
    amount_without_tax: 142.4,
    tax_amount: 25.64,
    tax_rate: 0.18,
    purchased_product_costs: [
      {
        sku: 'SKU-12',
        entity: {
          entity_identifier: '1',
          entity_type: 'site',
          entity_label: 'Default site ',
        },
        amount_without_tax: 79.2,
        amount_with_tax: 93.46,
        tax_amount: 14.26,
        tax_rate: 0.18,
        component_costs: [
          {
            component_identifier: 'ASK_OBSERVE_BUNDLE_DEDUCTION',
            amount_with_tax: -23.36,
            amount_without_tax: -19.8,
            tax_amount: -3.56,
            tax_rate: 0.18,
          },
          {
            component_identifier: 'SERVICE',
            amount_with_tax: 116.82,
            amount_without_tax: 99,
            tax_amount: 17.82,
            tax_rate: 0.18,
          },
        ],
      },
      {
        sku: 'SKU-2',
        entity: {
          entity_identifier: '1',
          entity_type: 'site',
          entity_label: 'Default site ',
        },
        amount_without_tax: 63.2,
        amount_with_tax: 74.58,
        tax_amount: 11.38,
        tax_rate: 0.18,
        component_costs: [
          {
            component_identifier: 'ASK_OBSERVE_BUNDLE_DEDUCTION',
            amount_with_tax: -18.64,
            amount_without_tax: -15.8,
            tax_amount: -2.84,
            tax_rate: 0.18,
          },
          {
            component_identifier: 'SERVICE',
            amount_with_tax: 93.22,
            amount_without_tax: 79,
            tax_amount: 14.22,
            tax_rate: 0.18,
          },
        ],
      },
    ],
  },
  payment_method: {
    payment_method_type: 'CREDIT_CARD',
    details: {
      card_number: '************4242',
      expiration_month: 3,
      expiration_year: 2025,
      credit_card_type: 'VISA',
    },
  },
};
